import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 12 14",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fill: "currentColor",
	d: "M11.2626 3.57161C11.5326 3.3016 11.6812 2.94301 11.6812 2.56156C11.6812 2.18011 11.5326 1.82152 11.2626 1.55151L10.1297 0.418593C9.85967 0.148579 9.50108 0 9.11964 0C8.73819 0 8.3796 0.148579 8.1103 0.417879L0.515625 7.98898V11.1427H3.66793L11.2626 3.57161ZM9.11964 1.42864L10.2533 2.56085L9.11749 3.69233L7.98458 2.56013L9.11964 1.42864ZM1.94427 9.71407V8.58187L6.9731 3.56875L8.10601 4.70167L3.0779 9.71407H1.94427ZM0.515625 12.5714H11.9448V14H0.515625V12.5714Z"
}));
const ForwardRef = forwardRef(SvgEdit);
export default ForwardRef;
